var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterviewScheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3151_17385",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#169c50"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3151_17385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6247 65.898L60.9455 50.5772C61.565 49.9577 62.3115 49.641 63.1851 49.6272C64.058 49.614 64.8177 49.9306 65.4643 50.5772C66.1108 51.2237 66.4341 51.9768 66.4341 52.8365C66.4341 53.6963 66.1108 54.4494 65.4643 55.0959L48.2611 72.3001C47.5077 73.0528 46.6288 73.4292 45.6247 73.4292C44.6205 73.4292 43.7417 73.0528 42.9882 72.3001L34.5351 63.8459C33.9156 63.2265 33.599 62.4799 33.5851 61.6063C33.5719 60.7334 33.8886 59.9737 34.5351 59.3272C35.1816 58.6806 35.9347 58.3574 36.7945 58.3574C37.6542 58.3574 38.4073 58.6806 39.0538 59.3272L45.6247 65.898ZM22.1153 89.5834C20.0104 89.5834 18.2288 88.8542 16.7705 87.3959C15.3122 85.9376 14.583 84.156 14.583 82.0511V26.2824C14.583 24.1775 15.3122 22.3959 16.7705 20.9376C18.2288 19.4792 20.0104 18.7501 22.1153 18.7501H27.884V13.1407C27.884 12.2275 28.19 11.465 28.8018 10.8532C29.4136 10.2421 30.1761 9.93652 31.0893 9.93652C32.0031 9.93652 32.7656 10.2421 33.3768 10.8532C33.9886 11.465 34.2945 12.2275 34.2945 13.1407V18.7501H65.8653V13.0615C65.8653 12.1747 66.1643 11.432 66.7622 10.8334C67.3608 10.2355 68.1035 9.93652 68.9903 9.93652C69.8771 9.93652 70.6195 10.2355 71.2174 10.8334C71.816 11.432 72.1153 12.1747 72.1153 13.0615V18.7501H77.884C79.9889 18.7501 81.7705 19.4792 83.2288 20.9376C84.6872 22.3959 85.4163 24.1775 85.4163 26.2824V82.0511C85.4163 84.156 84.6872 85.9376 83.2288 87.3959C81.7705 88.8542 79.9889 89.5834 77.884 89.5834H22.1153ZM22.1153 83.3334H77.884C78.2049 83.3334 78.4986 83.1997 78.7653 82.9324C79.0327 82.6657 79.1663 82.3719 79.1663 82.0511V42.949H20.833V82.0511C20.833 82.3719 20.9667 82.6657 21.234 82.9324C21.5007 83.1997 21.7945 83.3334 22.1153 83.3334ZM20.833 36.699H79.1663V26.2824C79.1663 25.9615 79.0327 25.6678 78.7653 25.4011C78.4986 25.1337 78.2049 25.0001 77.884 25.0001H22.1153C21.7945 25.0001 21.5007 25.1337 21.234 25.4011C20.9667 25.6678 20.833 25.9615 20.833 26.2824V36.699Z",
    fill: "#169c50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewScheduled);
export default __webpack_public_path__ + "static/media/Interview Scheduled.e89a78f0416572bb115597dd4e7d926b.svg";
export { ForwardRef as ReactComponent };